export default "__VITE_ASSET__CyMGxNi6__"